import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState } from "react"
import { Row, Col, Alert, Container } from "reactstrap"
import { useHistory } from "react-router-dom"

//axios
import axios from "../api/axios"

//redux
import { useSelector, useDispatch } from "react-redux"

import { withRouter, Link } from "react-router-dom"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { userForgetPassword } from "../../store/actions"


// import images
import logo from "../../assets/images/logo-sm.svg"
import CarouselPage from "../AuthenticationInner/CarouselPage"


const ForgetPasswordPage = (props) => {


  const [showMsg, setshowMsg] = useState(false)
  const [showMsg1, setshowMsg1] = useState(false)
  const [forgetError, setForgetError] = useState("")
  const [forgetSuccessMsg, setForgetSuccessMsg] = useState("")

  const FORGOTPASS_URL = `/forget_password/reset-link`;

  const [sending, setSending] = useState(false)

  // Human message for any failed request — rate limit, server error, or no network.
  const describeError = (error) => {
    const status = error?.response?.status
    const serverMsg = error?.response?.data?.message
    if (status === 429) return serverMsg || "Too many reset requests. Please wait a while and try again."
    if (status >= 500) return "The server had a problem. Please try again in a moment."
    if (!error?.response) return "Could not reach the server. Check your connection and try again."
    return serverMsg || "Something went wrong. Please try again."
  }

  const ForgetPassword = async (url, data) => {
    setshowMsg(false)
    setshowMsg1(false)
    setForgetError("")
    setForgetSuccessMsg("")
    setSending(true)
    try {
      const response = await axios.post(url, data);
      const body = response.data || {}
      if (body.status === 200) {
        setshowMsg(true)
        if (Array.isArray(body.accounts) && body.accounts.length > 1) {
          setForgetSuccessMsg(`This email has ${body.accounts.length} accounts — a separate reset link was sent for each.`)
        }
      } else if (body.status === 400 && /doesn't exi/i.test(body.message || "")) {
        setshowMsg1(true)
      } else {
        setForgetError(body.message || "Something went wrong. Please try again.")
      }
    } catch (error) {
      setForgetError(describeError(error))
    } finally {
      setSending(false)
    }
  };

  const dispatch = useDispatch()

  const FORGET_PASSWORD = "/forget_password/get-otp"

  const [loading, setLoading] = useState(false)

  const history = useHistory()



  async function handleValidSubmit(event, values) {
    try {
      setLoading(true)

      const response = await axios.post(FORGET_PASSWORD, values);
      if (response.data.status == 200) {
        setForgetSuccessMsg(response.data.message)
        history.push("/page-two-step-verification", { email: values.email })
      } else {
        setForgetError(response.data.message)
      }
    } catch (e) {
      setForgetError(describeError(e))
    } finally {
      setLoading(false)
    }



    //dispatch(userForgetPassword(values, props.history))
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>

        Rentdigicare | Forgot Password

        </title>
      </MetaTags>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <Link to="/dashboard" className="d-block auth-logo">
                        <img src={logo} alt="" height="70" />
                      </Link>
                    </div>
                    <div className="auth-content my-auto">
                      <div className="text-center">
                        <h5 className="mb-0">Forgot Password</h5>
                        <p className="text-muted mt-2">Forgot password with Rentdigicare</p>
                      </div>

                      {forgetError && forgetError ? (
                        <Alert color="danger" style={{ marginTop: "13px" }}>
                          {forgetError}
                        </Alert>
                      ) : null}
                      {forgetSuccessMsg ? (
                        <Alert color="success" style={{ marginTop: "13px" }}>
                          {forgetSuccessMsg}
                        </Alert>
                      ) : null}

                      <AvForm className="custom-form mt-4"
                        // onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                        onValidSubmit={(e, v) => ForgetPassword(FORGOTPASS_URL, {
                          email: v.email,
                        })}
                      >
                        <div className="mb-3">
                          <AvField
                            name="email"
                            label="Email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            required
                          />
                        </div>
                        <div className="mb-3 mt-4">

                          <button className="btn btn-primary w-100 waves-effect waves-light" type="submit" disabled={sending}>
                            {sending ? "Sending…" : "Reset"}
                            {sending ? (
                              <div style={{ height: "15px", width: "15px", marginLeft: "5px" }} className="spinner-border" role="status"></div>
                            ) : null}
                          </button>

                        </div>
                        {showMsg ? <h6 className="text-success">Please check your registered email!</h6> : null}
                        {showMsg1 ? <h6 className="text-danger">No account was found for that email address.</h6> : null}
                      </AvForm>


                      {/* <div className="mt-5 text-center">
                        <p className="text-muted mb-0">Remember it ?  <a href="auth-login.html"
                          className="text-primary fw-semibold"> Sign in </a>
                        </p>
                      </div> */}

                    </div>
                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0"> {new Date().getFullYear()} © Rentdigicare</p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
    </React.Fragment >
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
